export const INSURANCE_PERMISSIONS = {
  GLOBEMED: 'globe-med-insurance',
};

export const MY_CARE_CLIX_PERMISSIONS = {
  SERVICES: 'services',
};

export const GLOBE_MED_CANCEL_CODES = {
  PERSONAL_REASONS: '7062',
  DOCTOR_UNAVAILABILITY: '7070',
};

export const MY_CARE_CLIX_INFO = {
  CLINIC_IDS: {
    ALL: ['myguardiandoc', 'myguardiandoc2', 'myguardiandocbusiness'],
    MAIN: ['myguardiandoc', 'myguardiandoc2'],
    BUSINESS: ['myguardiandocbusiness'],
  },
};
